import React from 'react';
import { Chip } from '@kvdbil/components';
import styled from 'styled-components';
import Link from '~/App/shared/components/Link';
import {
  ArticlesForCategoryDocument,
  ArticlesForCategoryQuery,
  CategoryRecord
} from '~/config/generated/graphql';
import { useCmsData } from '~/App/shared/hooks/useCmsData';
import { BlogArticlesForCategory } from '~/App/shared/interfaces/store/CmsData';

const StyledChip = styled(Chip)`
  &:hover {
    cursor: pointer;
  }
`;

interface Props {
  category: Partial<CategoryRecord>;
}

const BlogCategoryChip = ({ category }: Props) => {
  const { data, fetching } = useCmsData<
    ArticlesForCategoryQuery,
    BlogArticlesForCategory
  >({
    storeKey: 'blogArticlesForCategory',
    query: ArticlesForCategoryDocument,
    storeNestedKey: `categoryId-${category.id}`,
    options: {
      variables: { categoryId: category.id }
    }
  });

  const articleCount = fetching ? '' : (data?.allArticles?.length ?? 0);

  return (
    <Link key={category.name} to={`/ROUTES.BLOG/${category.slug}`}>
      <StyledChip color="neutral">{`${category.name} (${
        articleCount ?? ''
      })`}</StyledChip>
    </Link>
  );
};

export default BlogCategoryChip;
